@if (user(); as user) {
  <div>
    <mat-card-title class="pb-4">Basic Info</mat-card-title>
    <avs-inline-input
      (updated)="updateUserData({ firstName: $event }, user)"
      [showToast]="false"
      [value]="user.firstName"
      label="First Name"
      placeholder="First Name"
    />
    <avs-inline-input
      (updated)="updateUserData({ lastName: $event }, user)"
      [showToast]="false"
      [value]="user.lastName"
      label="Last Name"
      placeholder="Last Name"
    />
    <avs-inline-input
      [disabled]="true"
      [value]="userRoles[user.role.name].name"
      label="Role"
      placeholder="Role"
    />
    <mat-card-title class="pb-4">Contact Info</mat-card-title>
    <avs-inline-input
      [disabled]="true"
      [value]="user.email"
      label="E-mail"
      placeholder="email"
      type="email"
    />
    <avs-inline-input
      (updated)="updatePhoneNumber({ phoneNumber: $event }, user)"
      [mask]="{ mask: phoneMask(), placeholder: phoneMaskExpression() }"
      [placeholder]="phoneMask()"
      [showToast]="false"
      [value]="user.phone.number"
      sizeClass="w-[216px]"
      label="Phone number"
    >
      <avs-country-select
        class="mr-2"
        (changed)="updateCountryCode($event, user)"
        [showPhoneCode]="true"
        [value]="user.phone.countryCode || DEFAULT_COUNTRY.code"
      />
    </avs-inline-input>
    <div [ngClass]="isMobile ? '' : 'flex flex-row items-center mb-10 mt-5'">
      <mat-card-title class="w-52 mr-6">Password</mat-card-title>
      <button
        class="btn-yellow btn-medium"
        (click)="changePassword()"
        [ngClass]="isMobile ? 'w-full mt-5 mb-4' : ''"
      >
        CHANGE PASSWORD
      </button>
    </div>
    <div class="flex">
      <mat-card-title class="w-52 mr-6 mt-2.5">Notifications</mat-card-title>
      @if (!isMobile) {
        <div class="classic-form-item-wrapper mb-6">
          <ng-container *ngTemplateOutlet="optIn"></ng-container>
        </div>
      }
    </div>
    <div [ngClass]="isMobile ? 'pt-5' : 'flex flex-row ml-56 mb-2.5 w-[420px] px-2 justify-between'">
      <mat-slide-toggle
        class="test-mail-toggle main-toggle"
        (change)="toggleNotification($event, 'email', user)"
        [checked]="user.notificationsPreferences.emailEnabled"
        [disabled]="user.role.name === userRolesTypes.ReadOnly"
        labelPosition="before"
      >
        <span>Email:</span>
        {{ user.notificationsPreferences.emailEnabled ? 'On' : 'Off' }}
      </mat-slide-toggle>
      @if (isMobile) {
        <div class="mb-6">
          <ng-container *ngTemplateOutlet="optIn"></ng-container>
        </div>
      }
      <mat-slide-toggle
        class="test-sms-toggle main-toggle"
        (change)="toggleNotification($event, 'sms', user)"
        [checked]="user.notificationsPreferences.smsEnabled"
        [disabled]="user.role.name === userRolesTypes.ReadOnly || !user.phone.smsOptIn"
        disableRipple
        labelPosition="before"
      >
        <span>SMS:</span>
        {{ user.notificationsPreferences.smsEnabled ? 'On' : 'Off' }}
      </mat-slide-toggle>
    </div>

    @if (client()?.requireTotp && ('totp' | avsFeatureFlag)) {
      <avs-totp-auth />
    }

    <ng-template #optIn>
      <div>
        <mat-checkbox
          class="opt-in-checkbox -ml-2.5"
          (change)="updateSMSOptIn($event.checked, user)"
          [checked]="user.phone.smsOptIn"
        >
          SMS Opt-in message:
        </mat-checkbox>
        <p class="text-ui-dark text-sm mt-2">Checking the box indicates your consent to receive regular automated messages from Harmony at the provided phone number. You can Opt-Out and stop receiving automated messages by unchecking the box. Charges for messages and data may apply.</p>
      </div>
    </ng-template>
  </div>
}
